import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';
import { AmenityDtoSchema } from '../contracts';

const _GetAmenitiesByIdRequestDtoSchema = z.object({ facilityId: z.number() });

const GetAmenitiesByIdResponseDtoSchema = z.array(
  z.object({
    amenities: z.array(AmenityDtoSchema),
    category: z.object({ id: z.number(), name: z.string() }),
  })
);

export type GetAmenitiesByIdRequestDto = z.infer<
  typeof _GetAmenitiesByIdRequestDtoSchema
>;
export type GetAmenitiesByIdResponseDto = z.infer<
  typeof GetAmenitiesByIdResponseDtoSchema
>;

export const getAmenitiesById = (
  params: GetAmenitiesByIdRequestDto,
  config?: AxiosRequestConfig
) => {
  const { facilityId } = params;

  return api
    .get(`/amenities/facility/${facilityId}`, config)
    .then(responseContract(GetAmenitiesByIdResponseDtoSchema));
};
